
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'storedwelltime'
    })
  } // computed
}; // export default
